import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

import { DataLoginComponent } from './components/data-login/data-login.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoginPhoneFormComponent } from './components/login-phone-form/login-phone-form.component';
import { PhoneRegisterComponent } from './components/phone-register/phone-register.component';

const MODULES = [SharedModule];
const COMPONENTS = [
  DataLoginComponent,
  FooterComponent,
  LoginPhoneFormComponent,
  PhoneRegisterComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [...MODULES],
  exports: [...COMPONENTS, ...MODULES]
})
export class SharedPublicModule {}
